import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useHiringProcess } from '../../context/HiringProcessContext';
import { useTranslation } from 'react-i18next';

function Page2_JobDescription() {
  const {
    jobTitle,
    jdFile,
    setJdFile,
    processedJd,
    setProcessedJd,
    handleProcessJd,
    isProcessing,
    fileInputRef,
    setStep
  } = useHiringProcess();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleContinue = () => {
    setStep(3);
    navigate('/start-hiring/team');
  };

  const handleGoBack = () => {
    setStep(1);
    navigate('/start-hiring');
  };

  return (
    <div className="li-card" style={{ padding: '24px' }}>
      <div style={{ borderBottom: '1px solid #e0e0e0', paddingBottom: '16px', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '20px', fontWeight: '600', margin: 0 }}>{jobTitle}</h2>
        <span style={{ fontSize: '14px', color: 'rgba(0,0,0,0.6)' }}>Step 1: Define Role</span>
      </div>
      
      {/* Step 1: Upload & Process */}
      <div style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>{t('startHiring.step1Title')}</h3>
        <p style={{ fontSize: '14px', color: 'rgba(0,0,0,0.6)', marginBottom: '16px' }}>{t('startHiring.step1Subtitle')}</p>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <button className="li-btn-outline-secondary" onClick={() => fileInputRef.current.click()} style={{ width: 'auto' }}>
            <svg viewBox="0 0 24 24" width="24px" height="24px" fill="currentColor" style={{ marginRight: '8px' }}>
              <path d="M21.13 11.35a3.55 3.55 0 00-5 0l-8 8a1.73 1.73 0 002.45 2.45l8-8a.66.66 0 00-1-1l-8 8a.42.42 0 01-.58-.6l8-8a2.22 2.22 0 013.14 3.14l-8.42 8.42a3.56 3.56 0 01-5.08-5l9.43-9.43a.65.65 0 00-.92-.92L5.73 17.81a4.87 4.87 0 006.9 6.83l8.5-8.5a3.52 3.52 0 000-4.79z"></path>
            </svg>
            Upload JD
          </button>
          <input type="file" ref={fileInputRef} onChange={(e) => setJdFile(e.target.files[0])} accept=".pdf,.docx,.txt" style={{display: 'none'}} />
          
          <span style={{ fontSize: '14px', color: 'rgba(0,0,0,0.9)' }}>{jdFile ? jdFile.name : t('startHiring.noFileSelected')}</span>
          
          {jdFile && (
            <button onClick={handleProcessJd} className="li-btn-primary" disabled={isProcessing} style={{ marginLeft: 'auto' }}>
              {isProcessing ? t('startHiring.processing') : t('startHiring.processJd')}
            </button>
          )}
        </div>
      </div>

      {/* Step 2: Review & Edit JSON */}
      {processedJd && (
        <div style={{ marginBottom: '24px', borderTop: '1px solid #e0e0e0', paddingTop: '24px' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>{t('startHiring.step2Title')}</h3>
          <div className="form-group">
            <label style={{ display: 'block', fontSize: '12px', fontWeight: '600', color: 'rgba(0,0,0,0.6)', marginBottom: '4px' }}>
              {t('startHiring.reviewLabel')}
            </label>
            <textarea 
              value={processedJd} 
              onChange={(e) => setProcessedJd(e.target.value)} 
              rows="10" 
              style={{ 
                width: '100%', 
                fontFamily: 'monospace', 
                border: '1px solid rgba(0,0,0,0.6)', 
                borderRadius: '4px', 
                padding: '8px',
                fontSize: '14px' 
              }}
            />
          </div>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '32px', borderTop: '1px solid #e0e0e0', paddingTop: '16px' }}>
        <button onClick={handleGoBack} className="li-btn-outline-secondary" style={{ width: 'auto' }}>Go Back</button>
        <button onClick={handleContinue} className="li-btn-primary" disabled={!processedJd}>Continue</button>
      </div>
    </div>
  );
}

export default Page2_JobDescription;
